import { useRef, useState } from "react";
import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { FloatingPanel, useDismissOnOutsideClick } from "../../../components/ui/FloatingPanel.jsx";
import { ACCOUNT_USER_ROLES } from "../../../api/endpoints/accountPermissions.js";
import { getRolePalette } from "./accountPermissionTheme.js";

export function AccountPermissionRoleSelect({ value, onChange, disabled }) {
  const { c, dark } = useThemeSlice();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const panelRef = useRef(null);
  const palette = getRolePalette(value, dark);

  useDismissOnOutsideClick(open, () => setOpen(false), [anchorRef, panelRef]);

  const selectRole = (role) => {
    setOpen(false);
    if (role !== value) onChange(role);
  };

  const panelShadow = dark ? "0 12px 32px rgba(0,0,0,.5)" : "0 12px 32px rgba(15,23,42,.12)";

  return (
    <div style={{ display: "inline-block" }}>
      <button
        ref={anchorRef}
        type="button"
        disabled={disabled}
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          minWidth: 108,
          height: 30,
          padding: "0 10px 0 12px",
          borderRadius: 999,
          border: `1px solid ${palette.border}`,
          background: palette.bg,
          color: palette.text,
          fontSize: 11,
          fontWeight: 800,
          letterSpacing: "0.04em",
          cursor: disabled ? "wait" : "pointer",
          opacity: disabled ? 0.65 : 1,
        }}
      >
        {value}
        <span style={{ display: "flex", marginLeft: "auto", opacity: 0.8 }}>{Ico.chevDown}</span>
      </button>

      <FloatingPanel anchorRef={anchorRef} panelRef={panelRef} open={open} minWidth={148} gap={6}>
        <div
          style={{
            background: c.card,
            border: `1px solid ${c.cardBdr}`,
            borderRadius: 10,
            boxShadow: panelShadow,
            overflow: "hidden",
            padding: 4,
          }}
        >
          {ACCOUNT_USER_ROLES.map((role) => {
            const active = role === value;
            const rolePalette = getRolePalette(role, dark);
            return (
              <button
                key={role}
                type="button"
                onClick={() => selectRole(role)}
                style={{
                  width: "100%",
                  textAlign: "left",
                  border: "none",
                  borderRadius: 7,
                  padding: "8px 10px",
                  fontSize: 12,
                  fontWeight: active ? 800 : 600,
                  color: rolePalette.text,
                  background: active ? rolePalette.bg : "transparent",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
                onMouseEnter={(e) => {
                  if (!active) e.currentTarget.style.background = c.hover;
                }}
                onMouseLeave={(e) => {
                  if (!active) e.currentTarget.style.background = "transparent";
                }}
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: rolePalette.text,
                    flexShrink: 0,
                  }}
                />
                {role}
              </button>
            );
          })}
        </div>
      </FloatingPanel>
    </div>
  );
}
